import React from 'react';
import { certificatesLinks } from './constants';
import CertificateLink from './certificate-link';
function Certifications() {
  return <div className='flex w-full justify-center gap-6' data-sentry-component="Certifications" data-sentry-source-file="certifications.tsx">
            <CertificateLink item={certificatesLinks[0]} data-sentry-element="CertificateLink" data-sentry-source-file="certifications.tsx" />

            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a referrerPolicy='origin' target='_blank' rel='noopener' href='https://trustseal.enamad.ir/?id=146646&Code=YTOFZt96GEX92kC1GHto' className='rounded bg-surface-solid-0 px-0.5 py-0.5 lg:px-1'>
                <img referrerPolicy='origin' className='h-14 w-10 cursor-pointer object-contain lg:h-16 lg:w-[45px]' src='https://trustseal.enamad.ir/logo.aspx?id=146646&Code=YTOFZt96GEX92kC1GHto' alt='نماد اعتماد الکترونیک' data-code='YTOFZt96GEX92kC1GHto' />
            </a>
            <CertificateLink item={certificatesLinks[1]} data-sentry-element="CertificateLink" data-sentry-source-file="certifications.tsx" />
        </div>;
}
export default Certifications;